module.exports = __webpack_public_path__ + "static/media/0203.18b39587.png";